<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{snackbar_message}}</span>
      </v-snackbar>
      <v-card v-if="events" class="neu-glow pa-4 mb-5">
        <v-btn-toggle v-model="activeMonth" mandatory active-class="info white--text" class="d-flex justify-center flex-wrap background">
          <v-row>          
            <v-col class="px-1" v-for="(m,mi) in validMonths" :key="mi">
              <v-btn 
                block
                small
                class="mt-1 mb-3 neu-glow" 
                :value="m.i"
              >
                {{$vuetify.breakpoint.lgAndUp?m.name:m.name.substring(0,3)}}
              </v-btn>
            </v-col>
          </v-row>
        </v-btn-toggle>
        <v-row>
          <v-col cols="12">

            <!--
            <v-sheet
              v-if="$refs.calendar"
              tile
              height="54"
              class="d-flex"
            >
              <v-btn icon class="ma-2" @click="changeMonth(-1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
              <v-spacer></v-spacer>


              
              <div class="text-h4 pt-2" v-if="shownMonth">
                    {{ shownMonth }}
                  </div>
              <v-spacer></v-spacer>
              
              
              <v-btn icon class="ma-2" @click="changeMonth(1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
            </v-sheet>
            -->
            <v-sheet>
              <v-calendar 
                ref="calendar"
                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                v-model="calendarDate"
                type="month"
                show-week
                :start="startDate"
                :locale="settings.locale"
                event-height="36"
                :events="events"
                :event-margin-bottom="2"
                :event-color="getEventColor"
                :event-more="false"
                @click:event="showEvent"
              >
              </v-calendar>
              <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x
              >
                <v-card
                  color="grey lighten-4"
                  min-width="350px"
                  flat
                >
                  <v-toolbar
                    :color="selectedEvent.color"
                    dark
                  >
                    <v-toolbar-title>
                      <span v-html="selectedEvent.name"></span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <span v-html="selectedEvent.deposit?'Cauzione: '+(selectedEvent.deposit/1).toFixed(2):''"></span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      color="secondary"
                      @click="selectedOpen = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu> 
            </v-sheet> 
          </v-col>
        </v-row>
      </v-card>
      <v-card class="neu-glow pb-3">
        <v-card-title primary-title>
          <div class="text-h5">Riposo Settimanale</div>
            <v-spacer></v-spacer>
            <v-div>
              <!--             
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="closedWeekly_hash==JSON.stringify(closedWeekly)" @click.stop="saveItems('closedWeekly')">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>     
              -->         
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction_dow=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </v-div> 
        </v-card-title>
        <v-container grid-list-xl fluid>
          <v-row v-if="!allDays">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="6"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>            
          </v-row>
          <v-row class="mx-2 pb-4" v-else>
              <v-col cols="12">
                <v-btn-toggle v-model="lunch" multiple active-class="error white--text" class="d-inline">
                  <v-row>
                    <v-col cols="12">Pranzo</v-col>
                    <v-col v-for="(d,d2) in allDays||[]" :key="d2" class="px-1">
                      <v-btn 
                        :value="d.DOW"
                        :loading="loading"
                        block
                        class="neu-glow"
                      >
                        {{d.GDS}}
                      </v-btn>                     
                    </v-col>
                  </v-row>                  
                </v-btn-toggle>  
                <v-btn-toggle v-model="dinner" multiple active-class="error white--text" class="d-inline">
                  <v-row>
                    <v-col cols="12">Cena</v-col>
                    <v-col v-for="(d,d2) in allDays||[]" :key="d2" class="px-1">
                      <v-btn 
                        :value="d.DOW"
                        :loading="loading"
                        block
                        class="neu-glow"
                      >
                        {{d.GDS}}
                      </v-btn>                     
                    </v-col>
                  </v-row>                  
                </v-btn-toggle>                  
              </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card class="neu-glow mt-5 mb-1 pb-5" v-if="1==2">
        <v-card-title primary-title>
          <div class="text-h5">Eccezioni <span class="mr-3 text-caption">(ovvero giorni in cui il locale è aperto)</span></div>
            <v-spacer></v-spacer>
            <v-div>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  :disabled="closedExceptions_hash==JSON.stringify(closedExceptions)" :loading="loading_update"  @click.stop="saveItems('closedExceptions')">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop="editItem()">
                    <v-icon color="info">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>                           
            </v-div> 
        </v-card-title>
        <div class="mx-4">
          <v-data-table
            dense
            fixed-header
            :headers="headers_closedExceptions"
            :items="closedExceptions||[]"
            hide-default-footer
            :items-per-page=500
            item-class=""
            :loading="loading"
            no-data-text="Nessun dato presente in archivio"
            no-results-text="Nessun Risultato estratto"
            loading-text="Consultazione archivio: attendi..."
          >
            <template v-slot:[`item.dates`]="{ item }">
              <div>
                {{new Intl.DateTimeFormat(settings.options.location, { dateStyle: 'full' }).format(new Date(item.dates))}}
              </div>
            </template>

            <template v-slot:[`item.active`]="{ item }">
              <v-simple-checkbox
                v-model="item.active"
                color="info"
                @click="save2(item.active,'active',item.dateId)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.previousDayToo`]="{ item }">
              <v-simple-checkbox
                v-model="item.previousDayToo"
                color="info"
                 @click="save2(item.previousDayToo,'previousDayToo',item.dateId)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.lunch`]="{ item }">
              <v-simple-checkbox
                v-model="item.lunch"
                color="info"
                @click="save2(item.lunch,'lunch',item.dateId)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.dinner`]="{ item }">
              <v-simple-checkbox
                v-model="item.dinner"
                color="info"
                @click="save2(item.dinner,'dinner',item.dateId)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.previousDayLunch`]="{ item }">
              <v-simple-checkbox
                v-model="item.previousDayLunch"
                color="info"
                 @click="save2(item.previousDayLunch,'previousDayLunch',item.dateId)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.previousDayDinner`]="{ item }">
              <v-simple-checkbox
                inset
                v-model="item.previousDayDinner"
                color="info"
                 @click="save2(item.previousDayDinner,'previousDayDinner',item.dateId)"
              ></v-simple-checkbox>
            </template>                        


            <template v-slot:[`item.depositLunch`]="{ item }">
              <v-text-field
                v-model="item.depositLunch"
                label=""
                dense
                name="depositLunch"
                :id="item.dateId"
                class="neu-glow"
                prepend-inner-icon="mdi-currency-eur"
                solo
                @input.native="save"                
                reverse
                type="number"
                hide-details
              ></v-text-field>
            </template>
            <template v-slot:[`item.depositDinner`]="{ item }">
              <v-text-field
                v-model="item.depositDinner"
                label=""
                dense
                name="depositDinner"
                :id="item.dateId"
                class="neu-glow"
                prepend-inner-icon="mdi-currency-eur"
                solo
                @input.native="save"                
                reverse
                type="number"
                hide-details
              ></v-text-field>
            </template>
            <template v-slot:[`item.depositPreviousLunch`]="{ item }">
              <v-text-field
                v-model="item.depositPreviousLunch"
                label=""
                dense
                name="depositPreviousLunch"
                :id="item.dateId"
                class="neu-glow"
                prepend-inner-icon="mdi-currency-eur"
                solo
                @input.native="save"                
                reverse
                type="number"
                hide-details
              ></v-text-field>
            </template>                        
            <template v-slot:[`item.depositPreviousDinner`]="{ item }">
              <v-text-field
                v-model="item.depositPreviousDinner"
                label=""
                dense
                name="depositPreviousDinner"
                :id="item.dateId"
                class="neu-glow"
                prepend-inner-icon="mdi-currency-eur"
                solo
                @input.native="save"                
                reverse
                type="number"
                hide-details
              ></v-text-field>
            </template>
            <!--@click="save2(item.perviousDayToo,'previousDayToo',item)"-->
            <!--            
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error"
                    v-bind="attrs" v-on="on"
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Cancella</span>
              </v-tooltip> 
            </template>  
            -->        
          </v-data-table>
        </div>
      </v-card>      
    </v-form>
    <v-dialog v-model="dialog_instruction_dow" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction_dow = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Selezionare il giorno/i in cui il locale è chiuso per turno, quindi cliccare sul tasto  'Salva' (<v-icon color="error">mdi-content-save</v-icon>) che nel frattempo si sarà attivato.
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Nel giorno/i attivati, non sarà possibile, per i clienti, prenotare.
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vincoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare  prenotazioni anche nei giorni di chiusura.
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Di default sono elencati ed attivi, i giorni Festivi e le ricorrenze per le quali, di norma, i locali sono aperti anche se la ricorrenza cade nel/nei giorni di riposo settimanale.
                    </p>
                    <p>
                        Se il campo 'Attivo' è blu (<v-icon color="info">mdi-checkbox-marked</v-icon>) significa che quel giorno il locale è aperto e quindi il sistema accetta prenotazioni dirette da parte dei clienti
                    </p>
                    <p>
                      Il campo 'Precedente' attivo significa che, sempre in deroga alle chiusure settimanali, il locale è aperto anche il giorno che precede la ricorrenza.
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Per attivare o disattivare una opzione, cliccare sul relativo pulsante, quindi cliccare sul pulsante 'Salva' (<v-icon color="error">mdi-content-save</v-icon>) che nel frattempo si sarà attivato
                    </p>
                    <p>
                      E' possibile inserire nuove date premendo il pulsante <v-icon color="info">mdi-plus-circle</v-icon>: inserire i dati richiesti e premere il tasto Salva.
                    </p>
                    <p>
                      Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vincoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_edit" max-width="500"
      >
        <v-card>
          <v-card-title>
            Inserisci Giorno Aperto
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="hash==JSON.stringify(editedItem)" :loading="loading_update" @click="saveItem()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="editedItem.date=null;editedItem.description=null;editedItem.previousDayToo=null;dialog_edit = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12"> 
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.date"
                      label="Giorno"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.date"
                    locale="it"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu> 
              </v-col> 
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.description"
                  label="Descrizione"
                  prepend-inner-icon="mdi-book-edit"
                  outlined
                  hide-details
                ></v-text-field>              
              </v-col>
              <v-col cols="6">
                <v-switch
                  v-model="editedItem.lunch"
                  :label="editedItem.lunch?'Aperto a Pranzo':'Chiuso a Pranzo'"
                  prepend-inner-icon="mdi-calendar"
                  outlined
                  hide-details
                  color="info"
                ></v-switch>              
              </v-col> 
              <v-col cols="6">
                <v-switch
                  v-model="editedItem.dinner"
                  :label="editedItem.lunch?'Aperto a Cena':'Chiuso a Cena'"
                  prepend-inner-icon="mdi-calendar"
                  outlined
                  hide-details
                  color="info"
                ></v-switch>              
              </v-col>             
              <v-col cols="12">
                <v-switch
                  v-model="editedItem.previousDayLunch"
                  label="Aperto anche giorno precedente a Pranzo"
                  prepend-inner-icon="mdi-calendar"
                  outlined
                  hide-details
                  color="info"
                ></v-switch>              
              </v-col> 
              <v-col cols="12">
                <v-switch
                  v-model="editedItem.previousDayDinner"
                  label="Aperto anche giorno precedente a Cena"
                  prepend-inner-icon="mdi-calendar"
                  outlined
                  hide-details
                  color="info"
                ></v-switch>              
              </v-col>
            </v-row>                        
          </v-card-text>
          <!--
          <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="dialog_edit = false" color="info" v-bind="attrs" v-on="on">
                  <v-icon class="mr-2">mdi-close-circle</v-icon>
                  <span class="d-none d-md-block">Esci</span>
                </v-btn>
              </template>
              <span>Esci senza modificare</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="saveItem()" color="green" v-bind="attrs" v-on="on" :loading="loading_update">
                  <v-icon class="mr-2">mdi-save</v-icon>
                  <span class="d-none d-md-block">Salva</span>
                </v-btn>
              </template>
              <span>Salva Eccezione</span>
            </v-tooltip>
                      
          </v-card-actions>-->
        </v-card>
    </v-dialog>     
    <v-dialog v-model="dialog_delete" max-width="500px">
        <v-card>
            <v-card-title class="text-h5">Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Conferma</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>              
            </v-card-title>
        </v-card>
    </v-dialog>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from 'lodash'

export default {
  data() {
    return {
      page: "Settings",
      form: null,
      shownMonth:'',
      snackbar: false,     
      snackbar_message:null,
      snackbar_color:'success', 
      loading:false,
      loading_update:false,
      menu1:null,
      lunch:null,
      dinner:null,
      
      dialog_instruction:false,
      dialog_instruction_dow:false,
      dialog_edit:false,
      dialog_delete:false,
      editedItem:{date:null,description:null,previousDayToo:null},
      closedExceptions:null,
      closedExceptions_hash:null,
      allDays:null,
      closedWeekly:{"lunch":[],"dinner":[]},
      closedWeekly_hash:null,
      headers_closedExceptions: [
          //{ text: 'Tipo',             value: 'type',                align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          //{ text: 'Valore',           value: 'value',               align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Giorno',             value: 'dates',               align: 'start',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Descrizione',        value: 'description',         align: 'start',  sortable: false, class:'px-1 text-lg-button' },
          //{ text: 'Attivo',           value: 'active',              align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Pranzo',             value: 'lunch',               align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Cena',               value: 'dinner',              align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'GP Pranzo',          value: 'previousDayLunch',    align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'GP Cena',            value: 'previousDayDinner',   align: 'center',  sortable: false, class:'px-1 text-lg-button' },          
          //{ text: 'Precedente',       value: 'previousDayToo',      align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Anticipo Pranzo',    value: 'depositLunch',       align: 'center',  sortable: false, class:'px-1 text-lg-button', width:'120px' },
          { text: 'Anticipo Cena',      value: 'depositDinner',       align: 'center',  sortable: false, class:'px-1 text-lg-button', width:'120px' },
          //{ text: 'Anticipo GP Pranzo', value: 'depositPreviousLunch',       align: 'center',  sortable: false, class:'px-1 text-lg-button', width:'150px' },
          //{ text: 'Anticipo GP Cena',   value: 'depositPreviousDinner',       align: 'center',  sortable: false, class:'px-1 text-lg-button', width:'150px' },
          //{ text: 'Azione',           value: 'actions',             align: 'center',  sortable: false, class:'px-1 text-lg-button' },
      ],
    weekday: [1, 2, 3, 4, 5, 6, 0],
    calendarDate: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,    
    events:null,
    startDate:new Date().toISOString().split('T')[0],
    activeMonth:null,
    months:[
            {i:0,name:'Gennaio'},{i:1,name:'Febbraio'},{i:2,name:'Marzo'},{i:3,name:'Aprile'},{i:4,name:'Maggio'},{i:5,name:'Giugno'},{i:6,name:'Luglio'},{i:7,name:'Agosto'},
            {i:8,name:'Settembre'},{i:9,name:'Ottobre'},{i:10,name:'Novembre'},{i:11,name:'Dicembre'},{i:12,name:'Gennaio'},{i:13,name:'Febbraio'},{i:14,name:'Marzo'},{i:15,name:'Aprile'},
            {i:16,name:'Maggio'},{i:17,name:'Giugno'},{i:18,name:'Luglio'},{i:19,name:'Agosto'},{i:20,name:'Settembre'},{i:21,name:'Ottobre'},{i:22,name:'Novembre'},{i:23,name:'Dicembre'}
            ],
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    validMonths:function()
    {
      var d= new Date();
      var am=d.getMonth();
      this.activeMonth=am;
      //console.log('d:'+d,' - am:',am,'nonths:',this.months.filter((m,i)=>i<=12+am&&i>=am))
      return this.months.filter((m,i)=>i<=12+am&&i>=am)
    }
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){

    this.getData()

    //console.log(716,this.settings);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    
    this.$root.$on('refreshCalendar', data => {
        console.log(711,'refreshCalendar',data);
        this.getData();
    });
  },
  watch : {
    item (newValue) {
      console.log(540,newValue)
      //this.getData(newValue)
    },
    activeMonth(newValue,oldValue)
    {
      console.log(newValue,oldValue)
      if(oldValue)
      {
        var d= new Date();
        var fd=null;
        if (newValue<12)
        {
          fd=new Date(d.getFullYear(), d.getMonth(d.setMonth(newValue)), 2);
        }
        else
        {
          fd=new Date(d.getFullYear()+1, d.getMonth(d.setMonth(newValue)), 2);
        }
        this.startDate=fd;
        this.validMonths=this.months.filter((m,i)=>i+newValue<=12&&i>=newValue)
        console.log(725,fd,this.validMonths);
      }
    },
    /*
    shownMonth(newValue,oldValue)
    {
      console.log(694,newValue,oldValue);
      if(newValue!=oldValue&&this.$refs.calendar.title)
      {
        this.shownMonth=this.$refs.calendar.title;
      }
    },
    lunch(newValue,oldValue){
      console.log(544,newValue,oldValue,JSON.stringify(newValue),JSON.stringify(oldValue))
      if (JSON.stringify(newValue)!=JSON.stringify(oldValue))
      {
        console.log(547,newValue)
        this.save2(newValue,'closedWeekly','lunch') //TO BE ACTIVATED
      }
      else
      {
        if (newValue.lunch!=oldValue.lunch||newValue.dinner!=oldValue.dinner)
        {
        console.log(554,newValue)
        //this.save2(newValue,'closedWeekly') //TO BE ACTIVATED          
        }
      }
    },*/
    lunch(newValue,oldValue){
      console.log(751,newValue,oldValue,JSON.stringify(newValue),JSON.stringify(oldValue))
      if (JSON.stringify(newValue)!=JSON.stringify(oldValue)&&oldValue)
      {
        console.log(754,newValue)
        this.save2(newValue,'closedWeekly','lunch') //TO BE ACTIVATED
      }/*
      else
      {
        if (newValue.lunch!=oldValue.lunch||newValue.dinner!=oldValue.dinner)
        {
        console.log(761,newValue)
        //this.save2(newValue,'closedWeekly') //TO BE ACTIVATED          
        }
      }*/
    },
    dinner(newValue,oldValue){
      console.log(767,newValue,oldValue,JSON.stringify(newValue),JSON.stringify(oldValue))
      if (JSON.stringify(newValue)!=JSON.stringify(oldValue)&&oldValue)
      {
        console.log(770,newValue)
        this.save2(newValue,'closedWeekly','dinner') //TO BE ACTIVATED
      }/*
      else
      {
        if (newValue.dinner!=oldValue.dinner)
        {
        console.log(777,newValue)
        //this.save2(newValue,'closedWeekly') //TO BE ACTIVATED          
        }
      }*/
    },    
    assignedTable(newValue)
    {
      console.log(561,newValue)
      //this.assignedTables.push(newValue);
      console.log(563,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    changeMonth(m)
    {
      console.log(809,m)
    },
    changeMonth2(m)
    {
      console.log(734,this.$refs.calendar);
      if(this.$refs.calendar&&this.$refs.calendar.title)
      {
        console.log(736,this.$refs.calendar.title, this.$refs.calendar.lastEnd.date,this.$refs.calendar.value)
        this.shownMonth=this.$refs.calendar.title.toUpperCase()
      }
      if(m==-1)
      {
        this.$refs.calendar.prev()
      }
      else
      {
        this.$refs.calendar.next()
      }
      console.log(750,this.$refs.calendar);
      if(this.$refs.calendar&&this.$refs.calendar.title)
      {
        console.log(753,this.$refs.calendar.title, this.$refs.calendar.lastEnd.date,this.$refs.calendar.value)
        this.shownMonth=this.$refs.calendar.title.toUpperCase()
      }      
    },
    showEvent ({ nativeEvent, event }) {
      console.log(727,nativeEvent,event)
          if(event.name=='Pranzo'||event.name=='Cena'||event.name=='Aperitivo - Cena')
          //if(event.meal=='breakfast'||event.meail=='lunch'||event.meal=='cocktail'||event.meal=='dinner')
          //if(['breakfast','lunch','cocktail','dinner'].includes(event.meal))
          {
            event.color=event.color=='green'?'red':'green';
            var pload={"closedDate":event.start,"meal":event.meal,"value":event.color=='green'?0:1,"active":event.active};
            var action='saveItem';
            let payload={"action":action,"table":"ClosedDay","payload":pload};
            console.log(611,payload)
            console.log(612,this.$refs.calendar)
            console.log(612,this.$refs.calendar._uid)
            console.log(612,this.$refs.calendar.title)
            let rs=this.updateDB(payload)
            if (rs.errorid==='0')
            {
              console.log(event)
              this.snackbar_color="success"
              this.snackbar_message="OK"
              this.snackbar=true
            }
          }
          /*
          if(event.class=='ce'&& event.deposit)
          {          
            const open = () => {
            this.selectedEvent = event
            this.selectedElement = nativeEvent.target
            requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }
     }*/
      nativeEvent.stopPropagation()
    },
    getEventColor (event) {
      return event.color
    },    
    //@input.native="save"
   save: _.debounce( async function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      //console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      //var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":event.target.name,"value":value,"dateId":event.target.id};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllClosedWeekly_single","payload":pload};
      console.log(307,payload)
       var rs= await this.updateDB(payload)
       console.log(775,rs)
       if (rs.errorid=='0')
       {
        this.events=rs.payloads;
       }
    }, 1000),    
    /*
    save: _.debounce(function (event) {
      console.log(400,event,event.target.name,event.target.value)
      var v=event.target.value;
      var value=v===false?0:v===true?1:v===''?null:v;
      var userid=event.target.id;
      var pload={"parameter":field,"value":value,"userid":userid};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),    
    */
    async save2(value, field, dateId=null,item=null) {
      //@click="save2('manualConfirmation',value,s.slotId)"
      console.log(603,value, field,dateId,item);
      //var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":field,"dateId":dateId,"value":value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"AllClosedWeekly_single","payload":pload};
      console.log(611,payload)
      var rs=await this.updateDB(payload)
      console.log(807,rs)
      if (rs.errorid=='0')
      {
        this.events=rs.payloads;
      }      
    },    
    editItem()
    {
      this.dialog_edit=true;
      this.loading_update=false;
    },
    deleteItem(i)
    {
      this.editedItem=i;
      this.loading_update=false
      console.log(349,this.editedItem);
      this.dialog_delete=true;
    },
    async saveItem(a)
    {
        console.log(239,this.editedItem);
        this.loading_update=true;
        console.log(241,this.form);
        var action=a=='delete'?'deleteItem':'saveItem';
        let payload={"action":action,"table":"closedExceptions","payload":this.editedItem};
        console.log(253,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.dialog_delete=false;
        console.log(256,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.getData();
            this.editedItem.value=null;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },
    async saveItems(table)
    {
        this.loading_update=true;
        console.log(255,table,this[table],this.closedWeekly,this.closedExceptions);
        let payload={"action":"saveItem","table":table,"payload":JSON.stringify(this[table])};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.loading_refresh=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.payloads.message;
            this.snackbar = true;
            this.getData();
        }   
    },     
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"ClosedWeekly_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(280,res);
                this.loading_refresh=false;
                this.loading_update=false;
                this.loading=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.closedExceptions=res.data.payloads.closedExceptions
                    this.closedExceptions_hash=JSON.stringify(this.closedExceptions)                    
                    this.allDays=res.data.payloads.allDays;
                    this.lunch=res.data.payloads.allDays[0].lunch
                    this.dinner=res.data.payloads.allDays[0].dinner
                    this.events=res.data.payloads.events;
                    console.log(876,this.events)
                    //this.closedWeekly=res.data.payloads.allDays.filter(s => s.active>0).map(k => k.DOW);
                    //this.closedWeekly={"lunch":res.data.payloads.allDays[0].lunch,"dinner":res.data.payloads.allDays[0].dinner};
                    this.closedWeekly_hash=JSON.stringify(this.closedWeekly);                    
                    this.closedExceptions=res.data.payloads.closedExceptions
                    this.closedExceptions_hash=JSON.stringify(this.closedExceptions)
                    console.log(288,this.closedWeekly,this.closedExceptions)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(305,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(314);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(323);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style>
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td, .row-height-36
{
  height: 34px !important;
}
</style>